import {FormControl, Grid, InputLabel, Select} from "@mui/material";
import {SELECT_OPTIONS} from "@/components/types";
import MenuItem from '@mui/material/MenuItem';
import {getRandomNumber} from "@/components/shared/client/utils";

const CustomSelect = ({size, options, value, onChange, name, label, triggerOnChange = false, triggerForValuesOf = null}: SELECT_OPTIONS) => {
    return <Grid className="df we1">
        <FormControl fullWidth>
            {!!label && <InputLabel>{label}</InputLabel>}
            <Select
                size={size ?? "medium"}
                fullWidth
                label={label ?? ""}
                id={`select-${getRandomNumber({type: "uid"})}`}
                value={value ?? ""}
                onChange={(e) => onChange(e, null, triggerOnChange, triggerForValuesOf)}
                sx={{
                    backgroundColor: "backgrounds.main"
                }}
                name={name}
            >
                {options.map((option) => (
                    <MenuItem
                        key={`select-${getRandomNumber({type: "uid"})}`}
                        value={option.value}
                    >
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    </Grid>
}

export default CustomSelect;